export const API_URL = `${location.protocol}//${process.env.VUE_APP_API_HOST}/${process.env.VUE_APP_API_LIST_URL}`;
export const FILES_URL = `${location.protocol}//${process.env.VUE_APP_FILES_HOST}`;
export const XML_URL = `${location.protocol}//${process.env.VUE_APP_API_HOST}/${process.env.VUE_APP_API_XML_URL}`;
export const UPLOAD_URL = `${location.protocol}//${process.env.VUE_APP_API_HOST}/${process.env.VUE_APP_API_UPLOAD_URL}`;
